import React, { useState } from 'react';
import './components.css';
import famPhoto from './img/fam.jpg';
import davidPhoto from './img/david.jpg';

function About() {
  const [expanded, setExpanded] = useState(false);

  return (
    <section className="about" id="about">
      <div className="about-grid container">
        <div className="about-image-wrap">
          <img src={famPhoto} alt="The Jacobs family" className="about-image" />
          <img src={davidPhoto} alt="David Robinson" className="about-image-secondary" />
          <p className="about-image-caption">David & Priscilla Jacobs · Russ & Lesley Robinson</p>
        </div>

        <div className="about-text">
          <span className="kicker">02 — Our Story</span>
          <h2 className="about-title">
            Built by two families, one <em>book</em> at a time.
          </h2>

          <p className="about-lede">
            "We wanted a room that felt like a friend's living room — with 35,000 books
            on the walls and a chair always free."
          </p>

          <div className="about-body">
            <p>
              The Happy Book Stack began in 2022 when David Jacobs and his wife Priscilla
              opened their first shop in Murfreesboro, Tennessee. Their dream was simple:
              a cozy, welcoming room where neighbors could gather and slow down over a book.
            </p>

            {expanded && (
              <>
                <p>
                  Inspired by the warmth of the Tennessee store, David's long-time friend
                  Russ Robinson and his wife Lesley carried that vision out to Utah. A true
                  community man, Russ drew on his experience and local ties to help build a
                  new location from the ground up — hauling a semi-truck full of books and
                  shelves across the country to fill an empty building.
                </p>
                <p>
                  Every detail — the custom-built shelves, the quiet reading nooks, the
                  worn-soft chairs — is a nod to what we love: good stories and the people
                  who read them. We're less a bookstore than a meeting place, with 35,000
                  excuses to stay a little longer.
                </p>
              </>
            )}
          </div>

          <button
            className="read-more-button"
            onClick={() => setExpanded(v => !v)}
          >
            {expanded ? 'Read less' : 'Continue reading'}
          </button>
        </div>
      </div>
    </section>
  );
}

export default About;
